import { BaseCardWrapper } from '@healthhub/react-ui';
import { Typography } from 'antd';

import { Button } from '@shared/components/Button';

const { Title } = Typography;

interface Props {
  children: React.ReactNode;
  isHideEditBtn?: boolean;
  onEdit: () => void;
  title: string;
}

const InfoSummaryCard = ({ children, isHideEditBtn, onEdit, title }: Props) => (
  <BaseCardWrapper className="flex flex-col">
    <div className="flex items-center justify-between">
      <Title className="text-base" level={5}>
        {title}
      </Title>
      {!isHideEditBtn && (
        <Button className="text-sm font-semibold text-theme-600 hover:opacity-70" onClick={onEdit} variant="text">
          Edit
        </Button>
      )}
    </div>
    {children}
  </BaseCardWrapper>
);

export default InfoSummaryCard;
